export const timeRange = 15;

export const fiftyNineMinutes = 59;
